import React from "react";
import InfoBlock from "../../../common/InfoBlock";

const getBillingInfo = (billingInfo, header = "Billing Details") =>
  billingInfo && (
    <InfoBlock
      header={header}
      config={[
        {
          title: "Biller Name",
          value: billingInfo.billerName,
        },
        {
          title: "Billing Address",
          value: billingInfo.billingAddress,
          size: {
            lg: 8,
          },
        },
        {
          title: "Billing Cycle",
          value: billingInfo.billingCycleName,
          size: {
            sm: 6,
            xs: 6,
          },
        },
        {
          title: "Advance Amount",
          value: billingInfo.isAdvanceAmountRequired ? billingInfo.advanceAmount : "Not Required",
          size: {
            sm: 6,
            xs: 6,
          },
        },
        {
          title: "Order Region",
          value: billingInfo.orderRegionName,
          size: {
            sm: 6,
            xs: 6,
          },
        },
        {
          title: "Order Number",
          value: billingInfo.orderId,
          size: {
            sm: 6,
            xs: 6,
          },
        },
      ]}
    />
  );

export default getBillingInfo;
